import request from '@/utils/market/marketing'
// 经销商列表
export function vipsearch(data) { // 消费者查询
    return request({
      url: '/mtscitech/back/usermanager/search',
      method: 'post',
      data
    })
  }
  export function updatestate(query) { // 更新状态接口
    return request({
      url: '/mtscitech/back/usermanager/updatestate',
      method: 'get',
      params: query
    })
  }
  export function makeqrcode(query) { // 生成二维码
    return request({
      url: '/mtscitech/back/usermanager/qrcode',
      method: 'get',
      params: query
    })
  }
  export function registeruser(data) { // 用户注册
    return request({
      url: '/mtscitech/back/register/registeruser',
      method: 'post',
      data
    })
  }
  export function deletelist(data) { // 用户删除
    return request({
      url: '/mtscitech/back/usermanager/deletelist',
      method: 'post',
      data
    })
  }
  export function userupdate(data) { // 修改用户信息接口
    return request({
      url: '/mtscitech/back/usermanager/update',
      method: 'post',
      data
    })
  }
  export function getchildren(query) { // 渠道机构树
    return request({
      url: '/mtscitech/back/channellist/getchildren',
      method: 'get',
      params: query
    })
  }
  export function getchildrenonly(query) { // 查询一个父节点子节点
    return request({
      url: '/mtscitech/back/channellist/getchildrenonly',
      method: 'get',
      params: query
    })
  }

  // Niunaile定制报表
  export function findOutOrderPage(data) { // 修改用户信息接口
    return request({
      url: '/api/out/report/orderOut/findOutOrderPage',
      method: 'post',
      data
    })
  }